export default __webpack_public_path__ + "static/UnderConstruction-9d61609d0e48a5c2ad699a24cde5cf74.png";